module.exports = __webpack_public_path__ + "img/pr-4.c2302d15.png";